import { subYears } from 'date-fns';

export const validateAge = (input) => {
  const dateNow = new Date();
  const minDateOfBirth = subYears(dateNow, 18);

  const dateFormatJS = input.split('.').reverse().join('-');
  const inputDate = new Date(dateFormatJS);

  return inputDate < minDateOfBirth;
};
